
import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { Estado } from '../domain/estado.model';

export class EstadoSerializer extends DomainSerializer<Estado> {}
